import type { WidgetEffectParams } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorStatusCode from '@swf/sports/utils/getErrorStatusCode';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { AntePostEventsHandlerResponseBody, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    { dispatch, select, widget, rootState }: WidgetEffectParams<BasicSportsWidgetConfig>
  ) {
    const { antePostEventsRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    const widgetSelect: WidgetSelect = select[widget.uid];

    widget.unmount.subscribe(clear);

    const hasPreloaded = widgetSelect.hasPreloaded(rootState);
    if (!hasPreloaded) {
      await antePostEventsRequested();
    }
  },
  async antePostEventsRequested(
    _payload: undefined,
    params: WidgetEffectParams<BasicSportsWidgetConfig>
  ): Promise<void> {
    const { dispatch, request, widget, select, rootState } = params;
    const sportsRequest = buildSportsRequest(request, rootState);
    const { eventTypeId } = select.sports.getUrlParams(rootState);

    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    try {
      const { body } = await sportsRequest<AntePostEventsHandlerResponseBody>({
        path: `/ante-post-events/${eventTypeId}`,
        signal: getWidgetCancellationSignal(params)
      });

      widgetDispatch.dataLoadSuccess(body);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      widgetDispatch.dataLoadFailed(getErrorStatusCode(error));
    }
  }
};
